var ageRestrictedModule = function (order) {
    CheckoutSettings.ready(_.bind(function (s) {
        var mode = s.AgeRestrictedMode || 1;
        if (mode === 1) {
            new AgeRestrictedView(order);
        } else if (mode === 2) {
            AgeRestrictedDateView(order);
        }
    }, this));
};

var phoneNumberVerificationModule = function (order) {
    var model = new PhoneNumberVerification({}, { order: order });
    var view = new PhoneNumberVerificationView({ model: model });
    return model;
};

var _$stripeReady;
var _getStripe = function () {

    if (!_$stripeReady) {
        var $ready = new $.Deferred();
        CheckoutSettings.ready(_.bind(function(s) {
            if (s.StripeEnabled) {
                var stripe = new StripeHelper(s.StripePublicKey);
                stripe.init();
                $ready.resolve(stripe);
            }
        },  this));
        _$stripeReady = $ready.promise();
    }

    return _$stripeReady;
}

/* PayPal Module */
var braintreePayPalPaymentModule = function (logger, order, api, services, current, CheckoutSettings, Braintree, formButtonsContainer, checkoutButtonsContainer, allButtonsContainer, changeModeHandler) {
    var settings = CheckoutSettings.getBasketSettings();
    if (settings.UsePayPal || settings.UsePayPalCredit) {
        var _beforePaymentlogger = InsightLogger && InsightLogger.beforePayLogger && InsightLogger.beforePayLogger(order.get('Summary'), true);

        var paypal = new BraintreePayPal({},
            {
                 api: api, 
                 Braintree: Braintree,
                 logger: _beforePaymentlogger
            });

        var paypalcredit = new BraintreePayPal({},
            {
                 api: api, 
                 Braintree: Braintree,
                 logger: _beforePaymentlogger,
                 paymentOption: CheckoutSettings.PaymentOption.BrainTreePayPalCredit
            });

        var buttonClass = 'button-full pay-button';
        var paypalButtonContainetAll = 'paypal-button-container-all';
        var paypalCreditButtonContainetAll = 'paypal-credit-button-container-all';

        /* validate checkout before pay with paypal */
        var _validate = function(resolve, reject) {

            var value = services.pay.checkValid();

            if (value.result) {

                logger && logger();

                resolve({
                    amount: window.app.settingsUtils.getSiteDataGeneralSetting('FreeDeliveryPromo') &&
                        (!!order.get('Summary').get('Select')
                            ? order.get('Summary').get('TotalWithSelect') - order.get('Summary').get('Delivery')
                            : order.get('Summary').get('Total') - order.get('Summary').get('Delivery')) ||
                        order.get('Summary').get('Total'),
                    currency: GlobalSettings.Currency,
                    currencySing: GlobalSettings.CurrencySign,
                    displayName: GlobalSettings.SiteFullName,
                });

            } else {
                reject();
                setTimeout(function() {
                        (new HandleValidtionResultAction()).handle(value.reason, { backTo: this._backTo });
                    },
                    100);
            }
        };

        var _validatePayPal = function(resolve, reject) {
            window.app && app.event && app.event.paypal();
            _validate(resolve, reject);
        }

        var _validatePayPalCredit = function(resolve, reject) {
            window.app && app.event && app.event.paypalCredit();
            _validate(resolve, reject);
        }

        /* receive payment method from paypal and pay */
        var _pay = function (method) {
            services.pay.pay(paypal, method);
        }
        var _payCredit = function (method) {
            services.pay.pay(paypalcredit, method);
        }

        var currentMode;

        var _toggle = function (model, mode) {

            currentMode = mode || currentMode || 1;

            var showPayPal = _.some(model.attributes.AvailablePaymentOptions,
                function (po) {
                    return po.Name.toLowerCase() === CheckoutSettings.PaymentOption.BrainTreePayPal.toLowerCase();
                }) && currentMode === 1;

            var showPayPalCredit = _.some(model.attributes.AvailablePaymentOptions,
                function (po) {
                    return po.Name.toLowerCase() === CheckoutSettings.PaymentOption.BrainTreePayPalCredit.toLowerCase();
                }) && currentMode === 1;

            settings.UsePayPal && $('#' + paypalButtonContainetAll).toggle(showPayPal);
            settings.UsePayPalCredit && $('#' + paypalCreditButtonContainetAll).toggle(showPayPalCredit);
        }

        settings.UsePayPal && $('<div>').prop('id', paypalButtonContainetAll).addClass('pay-button__paypal test-paypal-button-all').appendTo(allButtonsContainer);
        settings.UsePayPalCredit && $('<div>').prop('id', paypalCreditButtonContainetAll).addClass(buttonClass + ' test-paypal-credit-button-all').appendTo(allButtonsContainer);

        order.on('change', _toggle);
        changeModeHandler.on('changeMode', function(e, mode) {
            _toggle(order, mode);
        });
        _toggle(order);

        Braintree.onSetupDone(_.bind(function () {
            if (Braintree.paypal.isEnabled()) {

                settings.UsePayPal && Braintree.paypal.createButton('#' + paypalButtonContainetAll, 'checkout', _validatePayPal, _pay, 50, 'paypal');

	            settings.UsePayPalCredit && Braintree.paypal.createButton('#' + paypalCreditButtonContainetAll, 'credit', _validatePayPalCredit, _payCredit, 50);

                _toggle(order);
            }
        }, this));

        var _logger = InsightLogger && InsightLogger.payButtonsClickLogger && InsightLogger.payButtonsClickLogger(order.get('Summary'), true);

        var _PayWithMethodButtonView = PayWithMethodButtonView.extend({
            click: function() {
                var logger = InsightLogger && InsightLogger.createLogger(_logger, InsightLogger.actions.payWithPayPal);
                logger && logger();
                window.app && app.event && app.event.currentPayPal();
                PayWithMethodButtonView.prototype.click.apply(this, arguments);
            }
        });
        var paypalMethodButtonView = new _PayWithMethodButtonView({ provider: paypal, service: services.pay, current: current, template: 'bt-checkout-button-paypal', container: checkoutButtonsContainer, order: order });

		// paypal free delivery adhoc feature
	    settings.UsePayPal &&
		    +!function enableFreeDeliveryLabel() {
			    if (!window.app.settingsUtils.getSiteDataGeneralSetting('FreeDeliveryPromo')) {
				    return;
			    }
			    var elem;
			    var elem2;
			    var elem_;
			    var elem2_;
			    var elem2__;
			    var elem__;
			    var notPPM = false;

			    current.on('change',
					function (m) {
						// if no payment method
						if (m.get('PaymentType') === undefined) return;

	                    if (m.get('PaymentType') === 'PayPal') {
							notPPM = false;
						    updLabel();
						    return;
					    }
					    elem && elem.remove();
					    elem2 && elem2.remove();
					    elem_ && elem_.remove();
					    elem2_ && elem2_.remove();
					    elem__ && elem__.remove();
					    elem2__ && elem2__.remove();
					    notPPM = true;

				    });

			    // NOTE: "first run condition" pattern applied
			    var firstRun = true;
			    DisplayRouter.GlobalDisplayHook.on(DisplayRouter.GlobalDisplayHook.eventTypes.changeDisplay, updLabel);

			    function updLabel() {
				    if (notPPM) {
					    return;
				    }
				    elem && elem.remove();
				    elem2 && elem2.remove();
				    elem_ && elem_.remove();
				    elem2_ && elem2_.remove();
				    elem__ && elem__.remove();
				    elem2__ && elem2__.remove();
				    var summary = order.get('Summary');
					var total = !!summary.get('Select') ? summary.get('TotalWithSelect') - summary.get('Delivery') : summary.get('Total') - summary.get('Delivery');
				    elem = $('<div>');
				    elem.html($.tmpl('bt-checkout-paypal-free-delivery-label-top',
					    { Total: window.toMoney(total, GlobalSettings.CurrencySign) }));
				    if (firstRun) {
					    summary.on('change',
						    function(summary) {
							    if (elem && elem_ && elem__) {
									var total = !!summary.get('Select') ? summary.get('TotalWithSelect') - summary.get('Delivery') : summary.get('Total') - summary.get('Delivery');
								    elem.html($.tmpl('bt-checkout-paypal-free-delivery-label-top',
									    { Total: window.toMoney(total, GlobalSettings.CurrencySign) }));
								    elem_.html($.tmpl('bt-checkout-paypal-free-delivery-label-top',
									    { Total: window.toMoney(total, GlobalSettings.CurrencySign) }));
								    elem__.html($.tmpl('bt-checkout-paypal-free-delivery-label-top',
									    { Total: window.toMoney(total, GlobalSettings.CurrencySign) }));
							    }
						    });
				    }
				    elem__ = elem.clone();
				    elem__.prependTo('#bt-checkout-buttons-current');
				    elem.insertBefore('#paypal-button-container');
				    elem_ = elem.clone();
				    elem_.insertBefore('#paypal-button-container-all');
				    elem2 = $('<div>');
				    elem2.html($.tmpl('bt-checkout-paypal-free-delivery-label-bottom'));
				    elem2.insertAfter('#paypal-button-container');
				    elem2_ = elem2.clone();
				    elem2_.insertAfter('#paypal-button-container-all');
				    elem2__ = elem2.clone();
				    elem2__.insertAfter($('#\\#bt-checkout-buttons-current-paypal').parent());
				    firstRun = false;
			    }
		    }();
    }
};

// TBD: refactor (make initialization more clean, use factories)
var braintreePaymentModule = function (order, api, services, strategy, strategiesOptsPay, current, CheckoutSettings, termsOurPay, payments, Braintree, wrapWith3DS, changeModeHandler) {
    var formButtonsContainer = '#bt-checkout-form-buttons';
    var checkoutButtonsContainer = '#bt-checkout-buttons-current';
    var allButtonsContainer = '#bt-checkout-buttons-all';
    var btFormId = 'bt-checkout-form';

    var stripeButtonView;
    var payWithStripeMethodButtonView;
    var braintreeButtonView;
    var payWithMethodButtonView;

    // TBD: need factory, because provider cannot be used for any service, only for particular service
    var _beforePaymentlogger = InsightLogger && InsightLogger.beforePayLogger && InsightLogger.beforePayLogger(order.get('Summary'), true);
    var providers = (function () {
        var providerOpts = {
            api: api,
            Braintree: Braintree,
            hideErrors: true,
            logger: _beforePaymentlogger
        };

        return {
            pay: new BraintreeCard({}, providerOpts),
            stripe: new StripeCard({ _getStripe: _getStripe }, providerOpts)
        }
    })(api, Braintree);

    services.threeDS = wrapWith3DS(strategy, strategiesOptsPay);

    //var braintreeFormView = new BraintreeFormView({
    //    form: btFormId
    //});

    var _logger = InsightLogger && InsightLogger.payButtonsClickLogger && InsightLogger.payButtonsClickLogger(order.get('Summary'), true);

	/* Pay with new Payment Method */

    var settings = CheckoutSettings.getBasketSettings();
    var _PaymentButtonView = PaymentButtonView.extend({
        click: function() {
            var logger = InsightLogger && InsightLogger.createLogger(_logger, InsightLogger.actions.payWithNewCreditCard);
            logger && logger();
            if (settings.StripeEnabled) {
                window.app && app.event && app.event.stripeCreditCard();
            } else {
                window.app && app.event && app.event.creditCard();
            }
            PaymentButtonView.prototype.click.apply(this, arguments);
        },
        _toggle: function () {
            CheckoutSettings.ready(_.bind(function(s) {
                var show = false;
                if (this.buttonType === 'stripe' && s.StripeEnabled ||
                    this.buttonType === 'braintree' && !s.StripeEnabled) {
                    show = true;
                }
                this.$el.toggle(show);
            }, this));
        }
    });
    stripeButtonView = new _PaymentButtonView({ service: services.stripe, provider: providers.stripe, current: current, template: 'bt-checkout-button-braintree', container: formButtonsContainer, order: order, buttonType: 'stripe' });
    braintreeButtonView = new _PaymentButtonView({ service: services.pay, service_3ds: services.threeDS, provider: providers.pay, current: current, template: 'bt-checkout-button-braintree', container: formButtonsContainer, order: order, buttonType: 'braintree' });


	/* Pay with  */
    var _PayWithMethodButtonView = PayWithMethodButtonView.extend({
        click: function() {
            var logger = InsightLogger && InsightLogger.createLogger(_logger, InsightLogger.actions.payWithCreditCard);
            logger && logger();
            if (this._provider && this._provider.stripe) {
                window.app && app.event && app.event.stripeCurrentCreditCard();
            } else {
                window.app && app.event && app.event.currentCreditCard();
            }
            PayWithMethodButtonView.prototype.click.apply(this, arguments);
        }
    });
    payWithStripeMethodButtonView = new _PayWithMethodButtonView({ provider: providers.stripe, service: services.stripe, current: current, template: 'bt-checkout-button-braintree', container: checkoutButtonsContainer, order: order });
    payWithMethodButtonView = new _PayWithMethodButtonView({ provider: providers.pay, service_3ds: services.threeDS, service: services.pay, current: current, template: 'bt-checkout-button-braintree', container: checkoutButtonsContainer, order: order });
    

    /* Initialize PayPal buttons */
    var paypalButtonAllLogger = InsightLogger && InsightLogger.createLogger(_logger, InsightLogger.actions.payWithNewPayPal);
    braintreePayPalPaymentModule(paypalButtonAllLogger, order, api, services, current, CheckoutSettings, Braintree, formButtonsContainer, checkoutButtonsContainer, allButtonsContainer, changeModeHandler);

    // TBD: Better to create factory instead of setting service to the button class.
    // Or make wrapper-view.
    order.on('change:ThreeDSecureRequired', function (model, value) {
    	if (value) {
	        braintreeButtonView && braintreeButtonView.setService(services.threeDS);
	        payWithMethodButtonView && payWithMethodButtonView.setService(services.threeDS);
    	} else {
	        braintreeButtonView && braintreeButtonView.setService(services.pay);
	        payWithMethodButtonView && payWithMethodButtonView.setService(services.pay);
        }
    });
};

var ourpayPaymentModule = function (order, api, services, strategy, strategiesOptsOurPay, current, CheckoutSettings, termsOurPay, payments, Braintree, wrapWith3DS, changeModeHandler) {
    var allButtonsContainer = '#bt-checkout-buttons-all';

    var ourPayPaymentProvider = new OurPayPayment({}, { api: api, Braintree: Braintree });
    var ourPayStripePaymentProvider = new StripeCardOurPay({ _getStripe: _getStripe}, { api: api });
	var ourpayModel = new BraintreeOurPay({}, { api: api });

	// TBD: need factory, because provider cannot be used for any service, only for particular service
	var providers = (function () {
		var providerOpts = {
			api: api,
            Braintree: Braintree,
            hideErrors: true
		};

		return {
			ourpay: new BraintreeCardPersistPaymentProvider({}, providerOpts)
		}
	})(api, Braintree);

    services.threeDSOurPay = wrapWith3DS(strategy, strategiesOptsOurPay);

	/* Ourpay with new payment method */
	var ourPayButtonView = new PaymentOurPayButtonView({
	    model: ourpayModel,
	    packageDetails: order.get('DeliveryServicePackageDetail'),
        service: services.ourpay,
        services: services,
        service_3ds: services.threeDSOurPay,
        provider: providers.ourpay,
        providers: {
            braintree: providers.ourpay,
            stripe: ourPayStripePaymentProvider
        },
        container: allButtonsContainer,
		// TBD: need another mechanism for test classes
		testClass: 'test-ourpay-new-braintree',
		termsOurPay: termsOurPay,
        current: current,
        order: order
    });


    /* Ourpay with current payment method */
    var ourPayView = new PayWithOurPayView({
        model: ourpayModel,
        packageDetails: order.get('DeliveryServicePackageDetail'),
        service: services.ourpay,
        services: services,
        service_3ds: services.threeDSOurPay,
        provider: ourPayPaymentProvider,
        providers: {
            braintree: ourPayPaymentProvider,
            stripe: ourPayStripePaymentProvider
        },
        container: allButtonsContainer,
		current: current,
		testClass: 'test-ourpay-braintree',
        termsOurPay: termsOurPay,
        order: order
    });

    var showExtraMessage = function () {
        var ourpayMode = order.get('OurPayMode');
        var showExtraMessage = ourpayMode === 2;
        $('@ourpayText').toggleClass('hidden-block', !showExtraMessage);
    }

    changeModeHandler.on('changeMode', function (e, mode) {
        showExtraMessage();
        ourPayButtonView.setCurrentMode(mode);
        ourPayView.setCurrentMode(mode);
    });

	// TBD: Better to create factory instead of setting service to the button class.
	// Or make wrapper-view.
	order.on('change:IsOurPayThreeDSecureRequired', function (model, value) {
		if (value) {
			ourPayButtonView.setService(services.threeDSOurPay);
			ourPayView.setService(services.threeDSOurPay);
		} else {
			ourPayButtonView.setService(services.ourpay);
			ourPayView.setService(services.ourpay);
        }
	});
};


var afterpayPaymentModule = function (order, serviceAfterpay, current, afterpayModel) {

    if (!CheckoutSettings.getBasketSettings().AfterpayEnabled) {
        return;
    }

    var allButtonsContainer = '#bt-checkout-buttons-all';

    var provider = new AfterPayPayment({}, { api: api });

    var _Buttton = PaymentButtonView.extend({
        click: function() {
            window.app && app.event && app.event.afterpay();
            PaymentButtonView.prototype.click.apply(this, arguments);
        }
    });

    /* All buttons form */
    new AfterpayButton({
        model: afterpayModel,
        buttonFac: function (container, tmplOpts) {
            return new _Buttton({
                service: serviceAfterpay,
                provider: provider,
                current: current,
                tmplOpts: tmplOpts,
                template: 'bt-checkout-button-afterpay-container',
                container: container,
                order: order
            });
        }
    }).renderTo(allButtonsContainer);

    // Do it after order sync to avoid ROKT confirmation page fail.
    order.on('sync', function () {
        var postdata = $('[id$=hidAfterpay]').val();
        if (postdata) {
            postdata = JSON.parse(postdata);
            if (postdata.status === 'SUCCESS') {
                serviceAfterpay.tryComplete(provider, postdata.token);
            }
        }
    });
};

var openpayPaymentModule = function (order, serviceOpenpay, current, openpayModel) {
    if (!CheckoutSettings.getBasketSettings().OpenpayEnabled) {
        return;
    }
    var allButtonsContainer = '#bt-checkout-buttons-all';

    var provider = new OpenPayPayment({}, { api: api });
    var _Buttton = PaymentButtonView.extend({
        click: function () {
            window.app && app.event && app.event.openpay();
            PaymentButtonView.prototype.click.apply(this, arguments);
        }
    });
    // All buttons form
    new OpenpayButton({
        model: openpayModel,
        buttonFac: function (container, tmplOpts) {
            return new _Buttton({
                service: serviceOpenpay,
                provider: provider,
                current: current,
                tmplOpts: tmplOpts,
                template: 'bt-checkout-button-openpay-container',
                container: container,
                order: order
            });
        }
    }).renderTo(allButtonsContainer);
    // Do it after order sync to avoid ROKT confirmation page fail.
    order.on('sync', function () {
        var postdata = $('[id$=hidOpenpay]').val();
        if (postdata) {
            postdata = JSON.parse(postdata);
            if (postdata.status === 'LODGED' || postdata.status === 'FAILED') {
                serviceOpenpay.tryComplete(provider, postdata);
            }
        }
    });
};


var klarnaPaymentModule = function (order, validator, confirmation, current) {
    if (!CheckoutSettings.getBasketSettings().KlarnaEnabled) {
        return;
    }

    var allButtonsContainer = '#bt-checkout-buttons-all';

    var prePayment = function () {
        var _validate = validator.validate();
        if (_validate.result) {
            return new $.Deferred().resolve().promise();
        }
        setTimeout(function () {
            (new HandleValidtionResultAction()).handle(_validate.reason, { backTo: 'checkout' });
        }, 100);
        return new $.Deferred().reject().promise();
    }

    var afterPayment = function (data) {
        if (data.Result && data.Value.isPaid) {
            confirmation.set({
                invoiceNo: data.Value.invoiceNo || data.Value.InvoiceNo,
                paymentID: data.Value.PaymentID,
                orderInfoResult: data.Value.OrderInfoResult,
                plannedTransactions: data.Value.PlannedTransactions,
                paymentType: data.Value.PaymentType,
                voucher: data.Value.voucher,
                un: data.Value.un,
                addressString: data.Value.AddressString || '',
                addressAdditionalData: data.Value.AddressAdditionalData
            });
        }
    }

    var toggle = function () {
        var isDirect = current.isDirect();
        var _show = _.some(order.get('AvailablePaymentOptions'), function (po) {
            var show = po.Name.toLowerCase() === CheckoutSettings.PaymentOption.Klarna.toLowerCase();
            return show && !isDirect;
        });
        $('#klarna').toggleClass('hidden-block', !_show);
        $('#klarna-tc-text').toggleClass('hidden-block', !_show);
    }

    var klarna = KlarnaHelper(prePayment, afterPayment /*, app.models.payment.payHumm*/);
    klarna.appendTo($(allButtonsContainer), $('#klarna-tc-text'));

    order.on('sync', function () {
        order._onUpdateCheckout(toggle);
        toggle();
    });
};


var hummPaymentModule = function (order, validator, confirmation, current) {
    var settings = CheckoutSettings.getBasketSettings();

    if (!settings.HummEnabled) {
        return;
    }

    var _getGuestUserData = function () {
        var data = {};
        app.customerEmailModel.getValidatedEmail();
        data.email = app.customerEmailModel.get('email');
        data.name = window.__checkoutModel__.get('Delivery').get('Current').get('Name') || '';
        data.parameters = {};
        data.parameters.tcAccepted = app.customerEmailModel.getTC();
        data.parameters.emailsAccepted = app.customerEmailModel.getEmailAccept();
        return data;
    };

    if (window.Humm) {
        var humm2 = new Humm(settings.HummEndpoint);

        var prePayment = function () {
            var _validate = validator.validate();
            if (_validate.result) {
                var isAuth = !(app.cookie.get('us') === null || app.cookie.get('us') === 'unl');
                var callback = location.origin + location.pathname;
                if (isAuth) {
                    return api.createHummPaymentRequest({ callback: callback});
                } else {
                    var data = _getGuestUserData();
                    if (data.email) {
                        return api.createPublicHummPaymentRequest({ callback: callback, data: data });
                    }
                }
            }
            setTimeout(function() {
                (new HandleValidtionResultAction()).handle(_validate.reason, { backTo: 'checkout' });
            }, 100);
            return new $.Deferred().reject().promise();
        }

        var toggle = function () {
            var value = _.some(order.get('AvailablePaymentOptions'), function (po) {
                var show = po.Name.toLowerCase() === CheckoutSettings.PaymentOption.Humm.toLowerCase();
                return show && !isDirect;
            });
            var isDirect = current.isDirect();
            humm2.toggle(value && !isDirect);
        }

        var allButtonsContainer = $('#bt-checkout-buttons-all');


        allButtonsContainer.append('<div id="humm2">');
        humm2.init('humm2', order.get('Summary'), prePayment, true);

        // Do it after order sync to avoid ROKT confirmation page fail.
        order.on('sync', function () {
            var postdata = $('[id$=hidHumm]').val();
            if (postdata) {
                postdata = JSON.parse(postdata);
                if (postdata.x_result === 'completed') {
                    var isAuth = !(app.cookie.get('us') === null || app.cookie.get('us') === 'unl');
                    var method = _.bind((isAuth ? api.createHummOrder : api.createPublicHummOrder), api);
                    method({ data: postdata }, { wait: true })
                        .done(function(data) {
                            if (data.Result && data.Value.isPaid) {
                                confirmation.set({
                                    invoiceNo: data.Value.invoiceNo || data.Value.InvoiceNo,
                                    paymentID: data.Value.PaymentID,
                                    orderInfoResult: data.Value.OrderInfoResult,
                                    plannedTransactions: data.Value.PlannedTransactions,
                                    paymentType: data.Value.PaymentType,
                                    voucher: data.Value.voucher,
                                    un: data.Value.un,
                                    addressString: data.Value.AddressString || '',
                                    addressAdditionalData: data.Value.AddressAdditionalData
                                });
                            }
                        });
                }
            }
            order._onUpdateCheckout(toggle);
            toggle();
        });
    }
};


var zipPaymentModule = function (order, validator, confirmation, current) {
    var settings = CheckoutSettings.getBasketSettings();

    if (!settings.ZipEnabled) return;

    var loaded = false;
    var zip2 = $('<div id="zip2">');

    var allButtonsContainer = $('#bt-checkout-buttons-all');

    allButtonsContainer.append(zip2);


    var prePayment = function () {
        var _validate = validator.validate();

        if (_validate.result) {
            return new $.Deferred().resolve().promise();
        }

        setTimeout(function () {
            (new HandleValidtionResultAction()).handle(_validate.reason, { backTo: 'checkout' });
        }, 100);

        return new $.Deferred().reject().promise();
    }

    var afterPayment = function (paymentProvider, data) {
        if (data.Result && data.Value.isPaid) {
            confirmation.set({
                invoiceNo: data.Value.invoiceNo || data.Value.InvoiceNo,
                paymentID: data.Value.PaymentID,
                orderInfoResult: data.Value.OrderInfoResult,
                plannedTransactions: data.Value.PlannedTransactions,
                paymentType: data.Value.PaymentType,
                voucher: data.Value.voucher,
                un: data.Value.un,
                addressString: data.Value.AddressString || '',
                addressAdditionalData: data.Value.AddressAdditionalData
            });
        }
    }

    var toggle = function (model) {
        var isDirect = current.isDirect();

        var zipAU = _.some(order.get('AvailablePaymentOptions'), function (po) {
            return po.Name.toLowerCase() === CheckoutSettings.PaymentOption.ZipPayAU.toLowerCase();
        });

        var zipNZ = _.some(order.get('AvailablePaymentOptions'), function (po) {
            return po.Name.toLowerCase() === CheckoutSettings.PaymentOption.ZipPayNZ.toLowerCase();
        });

        var available = zipAU || zipNZ;

        if (zipAU && !loaded) {
            loaded = true;
            zip.appendAUButton(zip2.empty(), prePayment, afterPayment, true);
        }

        if (zipNZ && !loaded) {
            loaded = true;
            zip.appendNZButton(zip2.empty(), prePayment, afterPayment, 0, true);
            setTimeout(function () {
                zip.updateAmount(model.get('Total'));
            }, 500);
            model.on('change', function (m) {
                zip.updateAmount(m.get('Total'));
            });
        }

        zip2.toggle(available && !isDirect);
    }

    // Do it after order sync to avoid ROKT confirmation page fail.
    order.on('sync', function (m) {
        var postdata = $('[id$=hidZipPayAU], [id$=hidZipPayNZ]').val();
        if (postdata) {
            postdata = JSON.parse(postdata);
            //if (postdata.x_result === 'completed') {
            api.createZipCharge({ data: postdata }, { wait: true })
                .done(function (data) {
                    afterPayment('ZipPay', data);
                });
            //}
        }
        order._onUpdateCheckout(toggle);
        toggle(m.get('Summary'));
    });

};

var lPayModule = function (order, validator, confirmation, current) {
    var settings = CheckoutSettings.getBasketSettings();

    if (!settings.LPayEnabled) return;

    var loaded = false;
    var lpay2 = $('<div id="lpay2">');

    var allButtonsContainer = $('#bt-checkout-buttons-all');

    allButtonsContainer.append(lpay2);


    var prePayment = function () {
        var _validate = validator.validate();

        if (_validate.result) {
            return new $.Deferred().resolve().promise();
        }

        setTimeout(function () {
            (new HandleValidtionResultAction()).handle(_validate.reason, { backTo: 'checkout' });
        }, 100);

        return new $.Deferred().reject().promise();
    }

    var afterPayment = function (data) {
        if (data.Result && data.Value.isPaid) {
            confirmation.set({
                invoiceNo: data.Value.invoiceNo || data.Value.InvoiceNo,
                paymentID: data.Value.PaymentID,
                orderInfoResult: data.Value.OrderInfoResult,
                plannedTransactions: data.Value.PlannedTransactions,
                paymentType: data.Value.PaymentType,
                voucher: data.Value.voucher,
                un: data.Value.un,
                addressString: data.Value.AddressString || '',
                addressAdditionalData: data.Value.AddressAdditionalData
            });
        }
    }

    var toggle = function (model) {
        var isDirect = current.isDirect();

        var available = _.some(order.get('AvailablePaymentOptions'), function (po) {
            return po.Name.toLowerCase() === CheckoutSettings.PaymentOption.LPay.toLowerCase();
        });


        if (available && !loaded) {
            loaded = true;
            lpay.init(lpay2.empty(), prePayment, afterPayment, true);

            setTimeout(function () {
                lpay.updateAmount(model.get('Total'));
            }, 500);
            model.on('change', function (m) {
                lpay.updateAmount(m.get('Total'));
            });
        }

        lpay2.toggle(available && !isDirect);
    }

    // Do it after order sync to avoid ROKT confirmation page fail.
    order.on('sync', function (m) {

        var postdata = $('[id$=hidLPay]').val();
        if (postdata) {
            window.app && app.event && app.event.lPayCreateCharge();
            var isAuth = !(app.cookie.get('us') === null || app.cookie.get('us') === 'unl');
            if (isAuth) {
                return api.confirmLPayTransaction(JSON.parse(postdata), { wait: true })
                    .done(afterPayment);
            } else {
                return api.confirmPublicLPayTransaction(JSON.parse(postdata), { wait: true })
                    .done(afterPayment);
            }
        }

        order._onUpdateCheckout(toggle);
        toggle(m.get('Summary'));
    });

};


var applePayModule = function (order, validator, confirmation, current) {
    var settings = CheckoutSettings.getBasketSettings();

    if (!settings.PaymentRequestButtonEnabled) return;

    var providers = (function () {
        var providerOpts = {
            api: api,
            hideErrors: true
        };

        return {
            stripe: new StripeCard({ _getStripe: _getStripe }, providerOpts)
        }
    })(api);

    var applepay2 = $('<div id="stripePaymentRequestButton" class="pay-button__pr hidden-block">');

    var allButtonsContainer = $('#bt-checkout-buttons-all');

    allButtonsContainer.append(applepay2);


    _getStripe().done(function (stripe) {
        var summary = order.get('Summary');
        stripe.ready(function (s) {
            var stripePaymentRequest = new StripePaymentRequest();
            stripePaymentRequest.init(s, prePayment, function(data) {
                return providers.stripe.complete(data).
                    then(function(result) {
                        afterPayment(result);
                    });
            }, summary.get('TotalWithSelect'), $('#stripePaymentRequestButton')[0]);

            summary.on('change', function (model) {
                stripePaymentRequest.update(model.get('TotalWithSelect'));
            });
        });
    });


    var prePayment = function () {
        var _validate = validator.validate();

        if (_validate.result) {
            return new $.Deferred().resolve().promise();
        }

        setTimeout(function () {
            (new HandleValidtionResultAction()).handle(_validate.reason, { backTo: 'checkout' });
        }, 100);

        return new $.Deferred().reject().promise();
    }

    var afterPayment = function (data) {
        if (data.Result && data.Value.isPaid) {
            confirmation.set({
                invoiceNo: data.Value.invoiceNo || data.Value.InvoiceNo,
                paymentID: data.Value.PaymentID,
                orderInfoResult: data.Value.OrderInfoResult,
                plannedTransactions: data.Value.PlannedTransactions,
                paymentType: data.Value.PaymentType,
                voucher: data.Value.voucher,
                un: data.Value.un,
                addressString: data.Value.AddressString || '',
                addressAdditionalData: data.Value.AddressAdditionalData
            });
        }
    }
};


var iPayPaymentModule = function (order, api, service, current, CheckoutSettings) {
    if (!CheckoutSettings.getBasketSettings().UseIPayMobile) {
        return;
    }

    //var formButtonsContainer = '#bt-checkout-form-buttons';
    var allButtonsContainer = '#bt-checkout-buttons-all';

    var ipay = new IPayPayment({}, { api: api });
    //var iPayButtonView = new IPayButtonView({ provider: ipay, service: service, current: current, template: 'bt-checkout-button-ipay', container: formButtonsContainer, order: order });
    var iPayButtonAllView = new IPayButtonView({ provider: ipay, service: service, current: current, template: 'bt-checkout-button-ipay', container: allButtonsContainer, order: order });

    // Do it after order sync to avoid ROKT confirmation page fail.
    order.on('sync', function () {
        var hidIPay = $('[id $= hidIPay]').val();
        service.tryComplete(ipay, hidIPay);
    });
};

var masterPassPaymentModule = function (order, api, service, current, isMobile, CheckoutSettings, globalQueryParams, GlobalSettings, changeModeHandler) {
	if (!CheckoutSettings.getBasketSettings().UseMasterPass) {
		return;
	}

	//var formButtonsContainer = '#bt-checkout-form-buttons';
	var checkoutButtonsContainer = '#bt-checkout-buttons-current';
	var allButtonsContainer = '#bt-checkout-buttons-all';
	var live = 'https://masterpass.com/lightbox/Switch/integration/MasterPass.client.js';
	var sundbox = 'https://sandbox.masterpass.com/lightbox/Switch/integration/MasterPass.client.js';

	var masterpass = new MasterPassPopup({}, { api: api, isMobile: isMobile, scriptUrl: (GlobalSettings.EHS ? live : sundbox) });
	
    /* New Masterpass */
    var _PaymentButtonView = PaymentButtonView.extend({
        click: function() {
            window.app && app.event && app.event.masterpass();
            PaymentButtonView.prototype.click.apply(this, arguments);
        }
    });
    //var mpButtonView = new _PaymentButtonView({ provider: masterpass, service: service, current: current, template: 'bt-checkout-button-masterpass', container: formButtonsContainer, order: order });
    var mpButtonAllView = new _PaymentButtonView({ provider: masterpass, service: service, current: current, template: 'bt-checkout-button-masterpass', container: allButtonsContainer, order: order, changeModeHandler: changeModeHandler });
	
    /* Current Masterpass */
    //var _PayWithMethodButtonView = PayWithMethodButtonView.extend({
    //    click: function() {
    //        window.app && app.event && app.event.currentMasterpass();
    //        PayWithMethodButtonView.prototype.click.apply(this, arguments);
    //    }
    //});
    //var mpMethodButtonView = new _PayWithMethodButtonView({ provider: masterpass, service: service, current: current, template: 'bt-checkout-button-masterpass', container: checkoutButtonsContainer, order: order });

	// Do it after order sync to avoid ROKT confirmation page fail.
	order.on('sync', function () {
		service.tryComplete(masterpass, globalQueryParams);
	});
};

var visaPaymentModule = function (order, api, service, strategy, strategiesOptsPay, current, HandleValidtionResultAction, Braintree, wrapWith3DS, changeModeHandler) {
	if (!CheckoutSettings.getBasketSettings().Visa.Enabled) {
		return;
    }

    var threeDS = wrapWith3DS(strategy, strategiesOptsPay);

	var providerType = CheckoutSettings.getBasketSettings().Visa.ProviderType;

	// NOTE: enum can be found at https://apacsale.atlassian.net/wiki/spaces/CX/pages/277643695/Visa+Checkout+-+Purchase
	if (providerType === 2) {
        var visacheckout = new VisaPaymentBTProvider({}, { order: order, service: service, current: current, handleValidtion: HandleValidtionResultAction, bt: Braintree, changeModeHandler: changeModeHandler });

        order.on('change:IsVCOThreeDSecureRequired', function (model, value) {
            if (value) {
                visacheckout.setService(threeDS);
            } else {
                visacheckout.setService(service);
            }
        });

	} else {
		new VisaPaymentProvider({}, { order: order, service: service, current: current, handleValidtion: HandleValidtionResultAction, bt: Braintree });
    }
};

var directPaymentModule = function (order, api, service, current) {
    var checkoutButtonsContainer = '#bt-checkout-buttons-current';
    var direct = new DirectPayment({}, { api: api });
    var _PayWithMethodButtonView = PayWithMethodButtonView.extend({
        click: function() {
            window.app && app.event && app.event.directPayment();
            PayWithMethodButtonView.prototype.click.apply(this, arguments);
        }
    });
    new _PayWithMethodButtonView({ provider: direct, service: service, current: current, template: 'bt-checkout-button-braintree', container: checkoutButtonsContainer, backTo: 'checkout', order: order });
};

// TBD: come up better names for variables
// TBD: refactor (make initialization more clean)
var paymentsModule = function (order, purchasePixel, api, globalQueryParams, GlobalSettings, CheckoutSettings, paymentInfoPixel) {
    var payments = new PaymentMethods([], { api: api, order: order }),
		confirmation = new ConfirmationModel({ order: order }),
		current = new SelectedPaymentMethod({}, { payments: payments, order: order }),
        ageRestricted = ageRestrictedModule(order);

	/* Initialize Braintree*/

	// NOTE: not needed because of token request goes inside BraintreeHelper
    // var token = new BraintreeToken({}, { api: api });

	var Braintree = BraintreeHelper(PromiseUtil.resolved({}));

	// TBD: create abstract factories for terms, validators, strategies and services
    var terms = {
        pay: new TermsAndConditions({}, {
            termsMode: CheckoutSettings.getBasketSettings().TermsAndConditionsMode
        }),
        ourpay: order.get('TermsOurPay')
    };
    var validators = {
        pay: new PaymentValidator(order, terms.pay),
        ourpay: new PaymentValidator(order, null, terms.ourpay),
        afterpay: new PaymentValidator(order, null, null),
        openpay: new PaymentValidator(order, null, null),
        humm: new PaymentValidator(order, null, null)
    };

    var phoneVerification = phoneNumberVerificationModule(order);

    var strategiesOpts = {
        pay: {
            Confirmation: confirmation,
            Validator: validators.pay,
            PhoneNumberVerification: phoneVerification
        },

        ourpay: {
            Confirmation: confirmation,
            Validator: validators.ourpay,
            PhoneNumberVerification: phoneVerification,
			Braintree: Braintree
        }
    }

    var strategies = {
        pay: new PaymentCombinedStrategy([
            new PaymentValidationStrategy(strategiesOpts.pay),
            new PhoneVerificationStrategy(strategiesOpts.pay),
            new PaymentConfirmationStrategy(strategiesOpts.pay)
        ]),

        direct: new PaymentCombinedStrategy([
            new PaymentValidationStrategy(strategiesOpts.pay),
            new PaymentConfirmationStrategy(strategiesOpts.pay)
        ]),

        stripe: new PaymentCombinedStrategy([
            new PaymentValidationStrategy(strategiesOpts.pay),
            //new PhoneVerificationStrategy(strategiesOpts.pay),
            new PaymentConfirmationStrategy(strategiesOpts.pay)
        ]),

        visa: new PaymentCombinedStrategy([
            new PhoneVerificationStrategy(strategiesOpts.pay),
            new PaymentConfirmationStrategy(strategiesOpts.pay)
        ]),

        ourpay: new PaymentCombinedStrategy([
            new ForcePhoneVerificationStrategy(strategiesOpts.ourpay),
            new PaymentValidationStrategy(strategiesOpts.ourpay),
            new PhoneVerificationStrategy(strategiesOpts.ourpay),
			new PaymentConfirmationStrategy(strategiesOpts.ourpay)
        ]),

        afterpay: new PaymentCombinedStrategy([
            new PaymentConfirmationStrategy(strategiesOpts.pay)
        ]),

        openpay: new PaymentCombinedStrategy([
            new PaymentConfirmationStrategy(strategiesOpts.pay)
        ]),

    };
    var services = {
        pay: new PaymentServiceValidationCompat({}, {
            paymentStrategy: strategies.pay,
            Validator: validators.pay
        }),

        direct: new PaymentServiceValidationCompat({}, {
            paymentStrategy: strategies.direct,
            Validator: validators.pay
        }),

        stripe: new PaymentServiceValidationCompat({}, {
            paymentStrategy: strategies.stripe,
            Validator: validators.pay
        }),

        visa: new PaymentServiceValidationCompat({}, {
            paymentStrategy: strategies.visa,
            Validator: validators.pay
        }),

        ourpay: new PaymentServiceValidationCompat({}, {
            paymentStrategy: strategies.ourpay,
            Validator: validators.ourpay
        }),

        stripeOurpay: new PaymentServiceValidationCompat({}, {
            paymentStrategy: strategies.ourpay,
            Validator: validators.ourpay
        }),

        afterpay: new PaymentServiceValidationCompat({}, {
            paymentStrategy: strategies.afterpay,
            Validator: validators.afterpay,
        }),

        openpay: new PaymentServiceValidationCompat({}, {
            paymentStrategy: strategies.openpay,
            Validator: validators.openpay,
        })
    };
	/* End */

	// 3DS service.
    function wrapWith3DS(paymentStrategy, strategiesOptsPay) {
    	return new PaymentServiceValidationCompat({}, {
    		paymentStrategy: new PaymentCombinedStrategy([
                paymentStrategy,
                new Payment3DSStrategy({
                	threeDSAPI: new ThreeDSDecorator({
                		Braintree: Braintree
                	}),
                    summaryModel: order.get('Summary'),
                    deliveryServicePackageDetail: order.get('DeliveryServicePackageDetail'),
                	currentMethod: current,
                    delivery: order.get('Delivery').get('Current')
                })
    		]),
            Validator: strategiesOptsPay.Validator
    	});
    }

    var changeModeHandler = $({});

    // NOTE: ordering matters, because it's the same with buttons order at the screen
    applePayModule(order, validators.humm, confirmation, current);
    braintreePaymentModule(order, api, services, strategies.pay, strategiesOpts.pay, current, CheckoutSettings, terms.ourpay, payments, Braintree, wrapWith3DS, changeModeHandler);
    klarnaPaymentModule(order, validators.humm, confirmation, current);
    visaPaymentModule(order, api, services.visa, strategies.visa, strategiesOpts.pay, current, HandleValidtionResultAction, Braintree, wrapWith3DS, changeModeHandler);
    directPaymentModule(order, api, services.direct, current);
    masterPassPaymentModule(order, api, services.pay, current, true, CheckoutSettings, globalQueryParams, GlobalSettings, changeModeHandler);
    iPayPaymentModule(order, api, services.pay, current, CheckoutSettings);
    afterpayPaymentModule(order, services.afterpay, current, order.get('Afterpay'));
    openpayPaymentModule(order, services.openpay, current, order.get('Openpay'));
    zipPaymentModule(order, validators.humm, confirmation, current);
    lPayModule(order, validators.humm, confirmation, current);
    hummPaymentModule(order, validators.humm, confirmation, current);
    ourpayPaymentModule(order, api, services, strategies.ourpay, strategiesOpts.ourpay, current, CheckoutSettings, terms.ourpay, payments, Braintree, wrapWith3DS, changeModeHandler);


    new ConfirmationView({ model: confirmation, pixel: purchasePixel, order: order, currentMethod: current, paymentInfoPixel: paymentInfoPixel });
    new PaymentMethodsView({ model: payments, service: services.pay, changeModeHandler: changeModeHandler });
    new CheckoutButtonsView({ model: current });

    new TermsAndConditionsView({
        model: terms.pay,
        el: '@terms'
    });
};
// End Payments

var basketPageModule = function (model, removeFromCartPixel) {
    new LayoutView({ model: model });
    new BasketView({ model: model });
    new DeliveryModeSwitcherView(model);
    new ItemListView({ collection: model.get('ItemList'), removeFromCartPixel: removeFromCartPixel });
    new ShipmentsListView({ collection: model.get('ShipmentsList'), deliveryOptions: model.get('DeliveryOptions'), removeFromCartPixel: removeFromCartPixel });
    new SummaryView({ model: model.get('Summary'), shipmentsList: model.get('ShipmentsList') });
    new FreeShippingView({ model: model });

    new VouchersButtonView({ collection: model.get('Vouchers') });
    new VouchersPromoView({ model: model });

    new BasketEmptyView();
    new InformationView();

    if (CheckoutSettings.getBasketSettings().UsePayPal) {
        new InformationButtonView({
            templates: {
                link: '_StoringCCDetailsLinkText',
                info: '_StoringCCDetailsNotification'
            },
            el: '@checkout-information-button'
        });
    }
};

// Entry point.
// ReSharper disable once WrongExpressionStatement
!function ($, _basketSettings) {
    _basketSettings.ready().then(function() {
        $(function () {
            var checkoutModel = new CheckoutModel(),
                purchasePixel = new PurchasePixel(),
                beginCheckout = new BeginCheckoutPixel();
                removeFromCartPixel = new RemoveFromCartPixel();
                paymentInfoPixel = new AddPaymentInfoPixel();
                shippingInfoPixel = new ShippingInfoPixel();

            var isInitialized = false;

            // global hook for checkout model, bad pattern, but it's OK for ASAP feature
            window.__checkoutModel__ = checkoutModel;

            new DeliveryOptionsButtonView({ model: checkoutModel });
            new DeliveryOptionsView({ collection: checkoutModel.get('DeliveryOptions') });
            basketPageModule(checkoutModel, removeFromCartPixel);
            paymentsModule(checkoutModel, purchasePixel, api, globalQueryParams, GlobalSettings, CheckoutSettings, paymentInfoPixel);
            deliveryModule(checkoutModel.get('Delivery'), shippingInfoPixel);

            new EstimateDeliveryPriceView({ model: checkoutModel });

            CustomerEmailModule.init(checkoutModel);
            
            checkoutModel._onUpdateCheckout(function(data) {

                var value = data && data.Value || {};
                if(!isInitialized)
                {
                    beginCheckout && beginCheckout.trigger(value);
                    isInitialized = true;
                }

                Pixel.events.trigger('basketUpdate', value);
            });

            checkoutModel.fetch();

        });
    });

}(jQuery, app.settings);